export type AllowedColours = typeof greenDark | typeof greenMid | typeof greenLight;

export const greenDark = "#06332B";
export const greenMid = "#1F8374";
export const greenLight = "#30BC94";

export const colourObj: {[key: string]: AllowedColours } = {
  underprepared: greenDark,
  progressing: greenMid,
  prepared: greenLight,
};
